// Swiper
import Swiper from 'swiper';  
import { Scrollbar, Navigation } from 'swiper/modules'
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation'


const swiperGallery = document.querySelectorAll('.gallery-slider');

if(swiperGallery) {
    const swiper = new Swiper('.gallery-slider', {
        modules: [Scrollbar],
        spaceBetween: 40,
        slidesPerView: 4,
        scrollbar: {
            el: '.swiper-scrollbar',
            draggable: true,
            dragClass: 'swiper-scrollbar-drag',
            hide: false,
            dragSize: 1,
        },
        breakpoints: {
            767: {
                slidesPerView: 4,
            },
            559: {
                slidesPerView: 3,
                spaceBetween: 20
            },
            320: {
                slidesPerView: 2,
                spaceBetween: 10
            },
        }
    });
}

const simpleGallery = document.querySelectorAll(".simple-gallery");

if(simpleGallery) {
    const simpleSlider = new Swiper('.simple-gallery', {
        modules: [Navigation],
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slidesPerView: 1
    })
}




